/** 屏蔽 number 输入框的「滚轮增减」误操作 */

import { useEffect } from 'react';

/**
 * 聚焦 number 输入框时，浏览器默认「滚轮一格 = 一个 step」——手输完成后滚动页面，
 * 光标只要在框内就会改值（数量 21 → 20.998、单价 75 → 74.99），纯误操作无正当用途。
 *
 * <p>实现要点：</p>
 * <ul>
 *   <li>React 的 onWheel 是根上 passive 监听，preventDefault 无效 → 必须挂原生非 passive capture 监听；</li>
 *   <li>只在「目标是 number 输入框且正处于聚焦」时拦截，未聚焦时页面/弹窗照常滚动；</li>
 *   <li>removeEventListener 按 capture 匹配（其重载不收 passive，传 { capture: true } 即可）。</li>
 * </ul>
 * 在 App 根组件调用一次即可全站生效（含后续新增页面）。
 */
export function useBlockNumberWheel(): void {
  useEffect(() => {
    const onWheel = (e: WheelEvent) => {
      const t = e.target;
      if (t instanceof HTMLInputElement && t.type === 'number' && document.activeElement === t) {
        e.preventDefault();
      }
    };
    document.addEventListener('wheel', onWheel, { passive: false, capture: true });
    return () => document.removeEventListener('wheel', onWheel, { capture: true });
  }, []);
}
